import { BaseService } from '#services/BaseService';
import { http } from '#utils/axios';

class CryptoWalletService extends BaseService {
  getOptionsList = (params) => {
    return http({
      params,
      url: `${this.endpoint}/`
    }).then(({ data }) => ({
      next: data.next,
      result: data.result?.map((el) => {
        return {
          data: el,
          label: `${el.device?.number} ${
            el.label ? ' (' + el.label + ')' : ''
          } | ${el.provider?.name || ''} | ${el.address || ''}`,
          value: el.id
        };
      })
    }));
  };

  constructor() {
    super('/crypto-wallet');
    if (!CryptoWalletService.instance) {
      CryptoWalletService.instance = this;
    }
    return CryptoWalletService.instance;
  }
}

const instance = new CryptoWalletService();
Object.freeze(instance);

export default instance;
